export default [
    {
        comment: '',
        error_id: 'RXY-01',
        data: [
            {cross_section: '44000.00', ds_cross_section: '4420', us_cross_section: '5505', diff: 15.20}
        ]
    }
]